// extracted by mini-css-extract-plugin
export var binWrap = "_bc-q";
export var cardContainer = "_bc-4";
export var cardContent = "_bc-5";
export var cardTappable = "_bc-t";
export var entering = "_bc-8";
export var productImage = "_bc-d";
export var productImageLg = "_bc-j";
export var productImageMd = "_bc-h";
export var productImagePlaceholder = "_bc-e";
export var productImagePlaceholderLg = "_bc-k";
export var productImagePlaceholderMd = "_bc-i";
export var productImagePlaceholderSm = "_bc-g";
export var productImagePlaceholderXl = "_bc-m";
export var productImageSm = "_bc-f";
export var productImageXl = "_bc-l";
export var progressBarBackground = "_bc-1";
export var progressBarContainer = "_bc-0";
export var progressBarFill = "_bc-2";
export var remainingCount = "_bc-r";
export var scanIconContainer = "_bc-3";
export var scanInputContainer = "_bc-o";
export var scanInputIconCircle = "_bc-n";
export var skipOverlay = "_bc-b";
export var slideInUp = "_bc-9";
export var slideOutRight = "_bc-7";
export var sliding = "_bc-6";
export var successOverlay = "_bc-a";
export var titleClamp = "_bc-s";
export var visible = "_bc-c";
export var workflowBottomBar = "_bc-p";